import apiClient from 'config/axios.config';

const reviewServices = {
  // LISTING
  getReviews: async (params = {}) => {
    const response = await apiClient.get(
      '/admin/listing/reviews',
      { params }
    );

    return response.data;
  },

  // TOGGLE VISIBILITY
  toggleVisibility: async (payload) => {
    const response = await apiClient.patch(
      '/admin/reviews/toggle-visibility',
      payload
    );

    return response.data;
  },

  exportReviews: async ({
  search,
  rating,
  userType,
   sortBy,
  sortOrder,
}) => {

  const params =
    new URLSearchParams({
      search: search || '',
      rating: rating || '',
      userType:
        userType || '',
         sortBy: sortBy || '',
    sortOrder: sortOrder || '',
    });

  for (const [key, value] of [
    ...params.entries(),
  ]) {
    if (!value) {
      params.delete(key);
    }
  }

  return apiClient.get(
    `/admin/listing/reviews/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
};

export default reviewServices;